import { useTranslation } from 'react-i18next'

import { sendNotification } from '@app/store/notifications'

import { useAppDispatch } from './useAppDispatch'

export const useNotificationsActions = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const showError = (message?: string) => {
    dispatch(
      sendNotification({
        message: message ?? t('Chat.Error'),
        kind: 'error',
      })
    )
  }

  return { showError }
}
